import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { useCallback } from "react";
import { ListContactGroups } from "../queries/useListContactGroups";

export const DeleteContactGroup = graphql(/* GraphQL */ `
	mutation DeleteContactGroup($params: DeleteContactGroupParams!) {
		deleteContactGroup(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useDeleteContactGroup() {
	const [deleteContactGroup] = useMutation(DeleteContactGroup, {
		refetchQueries: [ListContactGroups],
	});

	const handleDeleteContactGroup = useCallback(
		async (gid: GID) => {
			const result = await deleteContactGroup({
				variables: {
					params: {
						gid,
					},
				},
			});

			return {
				success: result.data?.deleteContactGroup.success,
				error: result.data?.deleteContactGroup.error,
			};
		},
		[deleteContactGroup]
	);

	return { handleDeleteContactGroup };
}
